import {Box, CircularProgress, Typography} from "@mui/material";
import React from "react";
import {DataGrid} from "@mui/x-data-grid";
import {useGetAllAccrualRequestsQuery} from "../../core/api/accrual-request-api";
import ActionAccrualRequestButton from "./ActionAccrualRequestButton";
import UserIdsListComponent from "./UserIdsListComponent";

const columns = [
    {field: 'id', headerName: 'id', hide: true},
    {field: 'authorName', headerName: 'Author name', width: 150},
    {field: 'category', headerName: 'Accrual reason', width: 150},
    {field: 'period', headerName: 'Period', width: 90},
    {field: 'receivers', headerName: 'Recipients', width: 200,
        renderCell: (params) => {
            return <UserIdsListComponent data={params.row.receivers}/>;
    }
    },
    {field: 'sum', headerName: 'Belcoins', width: 80,},
    {field: 'status', headerName: 'Status', width: 200,
        renderCell: (params) => {
            if (params.row.status === 'APPROVED') {
                return <div>Accrued</div>;
            } else if (params.row.status === 'REJECTED') {
                return <div>Rejected</div>;
            }
            return <ActionAccrualRequestButton request={params.row}/>;
        }
    },
    {field: 'reason', headerName: 'Comment', width: 200}

];
export default function RequestOfAccrualAdmin() {

    const {data: accrualRequest = [], isSuccess} = useGetAllAccrualRequestsQuery();

    return(
        isSuccess ?
            <Box>
                <Typography gutterBottom variant="body1" component="h3">
                    Belcoin accrual requests
                </Typography>
                <Box sx={{width: '100%', height: 600, mt: 0}}>
                    <DataGrid
                        rowHeight = {85}
                        rows={accrualRequest}
                        columns={columns}
                        pageSize={10}
                        rowsPerPageOptions={[10]}
                    />
                </Box>
            </Box> :
            <CircularProgress/>
    );

}